import React, { useCallback } from 'react'

import Card from '../../../Shared/Card'
import Icon from '../../../Shared/Icon'

import styles from './List.module.css'

export default function ListHeader({
  viewId,
  tableName,
  query,
  onChangeQuery,
}) {
  const handleChange = useCallback(
    e => {
      const value = e.currentTarget.value

      onChangeQuery(value)
    },
    [onChangeQuery]
  )

  return (
    <div className={styles.headerWrapper}>
      <Card noPad className={styles.headerCard}>
        <div className={styles.header}>
          <div className={styles.icon}>
            <Icon icon="search" color="grey" />
          </div>
          <input
            type="text"
            onChange={handleChange}
            value={query}
            placeholder={`Search ${(tableName || '').toLowerCase()}`}
            className={styles.searchInput}
          />
        </div>
      </Card>
    </div>
  )
}
